import { createGlobalStyle } from '@pata-app/themes';
import { appTheme as designSystemAppTheme } from '@pata-app/themes';

import { createStyledBreakpointsTheme } from 'styled-breakpoints';

const colors = {
  black: '#000000',
  white: '#FFFFFF',

  // Alerts
  error: '#D32F2F',
  info: '#0074e6',
  lightBlue: '#e5f2ff',
  lightGreen: '#eaf6ed',
  orange: '#f57f17',
  success: '#2e7b32',
  successAlt: '#00a33c',
  warning: '#fdd835',

  // Greyscale
  darkGrey: '#4b4b4b',
  grey: '#757575',
  lightGrey: '#f2f2f2',
  lighterGrey: '#f5f5f5',
  mediumGrey: '#d8d8d8',

  // Pata Colours
  pataBlue: '#117191',
  pataGreen: '#8cc4b8',
  pataTeal: '#90cfd1',
  pataOrange: '#f5a046',
  pataYellow: '#f5c14f',
};

export const breakpointTheme = createStyledBreakpointsTheme();

export const appTheme = {
  ...designSystemAppTheme,
  ...breakpointTheme,
  colors: {
    primary: {
      blue: colors.pataBlue,
      green: colors.pataGreen,
      teal: colors.pataTeal,
    },
    secondary: {
      orange: colors.pataOrange,
      yellow: colors.pataYellow,
    },
    greyscale: {
      white: colors.white,
      lighter: colors.lighterGrey,
      light: colors.lightGrey,
      medium: colors.mediumGrey,
      dark: colors.grey,
      darker: colors.darkGrey,
      black: colors.black,
    },
    info: {
      light: colors.lightBlue,
      medium: colors.info,
    },
    success: {
      light: colors.lightGreen,
      medium: colors.successAlt,
      dark: colors.success,
    },
    warning: {
      medium: colors.warning,
      dark: colors.orange,
    },
    danger: {
      medium: colors.error,
    },
  },
};

export const GlobalStyles = createGlobalStyle`

/* html, body, #root {
    height: 100%;

    color: ${({ theme }) => theme.core.colors.greyscale.black};
    
}

a {
  color: ${({ theme }) => theme.core.colors.info.medium};
  text-decoration: none;
}

button {
  &:active { 
    transform: scale(0.99);
  } 
} */


  html {
    scroll-behavior: smooth;
    background: ${({ theme }) => theme?.core?.colors?.greyscale?.white || '#fff'};
  }

  body{
    margin: 0;


    * {
  font-synthesis: none !important;
}

h2 {
  line-height: 1.3;
}



a {
  color: ${({ theme }) => theme.core.colors.primary.blue.medium};
  text-decoration: none;

  font-size: inherit;

  font-family: inherit;

  font-weight: 600;

  

}
  

    color: ${({ theme }) => theme?.core?.colors?.greyscale?.black || '#000'};
    
    >div:not(#recaptcha-portal) {
      display: flex;
      flex-direction: column;

      min-height: 100vh;

    }

    p {
      line-height: 1.5;
    }
  }

  
    * {
      box-sizing: border-box;
      font-family: 'Jost', sans-serif;
    }

    p {
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
    }


#modal-container {
  overflow: initial;
}

  




`;

export type TAppTheme = typeof appTheme;
